import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
    error: {
        marginTop: 16,
        maxWidth: 400,
    },
}));
